import thunkMiddleware from 'redux-thunk';
import { applyMiddleware, createStore } from "redux";
import rootReducer from "../Store/Reducers/RootReducer";
import { actionMiddleware } from '../middleware';

const store = createStore(rootReducer, applyMiddleware(thunkMiddleware, actionMiddleware));

export default store;